<template>
  <div class="fileinput fileinput-new" data-provides="fileinput">
    <div
      class="fileinput-new thumbnail"
      v-show="
        config.type != 'video' &&
          config.type != 'audio' &&
          config.type != 'article' &&
          config.type != 'model3d' &&
          config.type != 'unity3d'
      "
      style="width: 200px; height: 150px;margin-bottom:20px;"
      data-role="initImgPreview"
      :style="{
        width: config.type === 'audio' ? 'auto' : 200
      }"
    >
      <label v-if="!config.nolocal" :for="`file-${id}`" style="cursor:pointer">
        <img src="../assets/pages/img/noimage.png" />
      </label>
      <label v-else @click="openSpace()" style="cursor:pointer">
        <img src="../assets/pages/img/noimage.png" />
      </label>
    </div>
    <div
      class="fileinput-preview fileinput-exists thumbnail"
      style="/*max-height: 110px;*/max-width:50%;margin-left:0;margin-bottom: 20px;"
    ></div>
    <div>
      <span
        class="btn btn-file btn m-white m-btn-auto"
        v-show="!config.nolocal"
      >
        <span class="fileinput-new"> 本地上传 </span>
        <span class="fileinput-exists "> 重新选择 </span>
        <input
          data-role="file"
          type="file"
          :id="`file-${id}`"
          :name="config.name"
          :accept="config.accept || defaultAccepts[config.type]"
          @change="fileChg($event)"
        />
        <!-- v-model="config.fileName" -->
      </span>
      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'image'"
        @click="openSpace()"
      >
        从我的图片中选择
      </a>

      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'video'"
        @click="openVideoSpace()"
      >
        从我的视频中选择
      </a>
      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'audio'"
        @click="openAudioSpace()"
      >
        从我的音频中选择
      </a>
      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'model3d'"
        @click="openModel3dSpace()"
      >
        从我的3D模型中选择
      </a>

      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'unity3d'"
        @click="openUnity3dSpace()"
      >
        从我的3D场景中选择
      </a>

      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'miniapp'"
        @click="openMiniappSpace()"
      >
        从我的3D场景中选择
      </a>

      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto"
        v-if="config && config.space == 'article'"
        @click="openArticleSpace()"
      >
        从我的文章中选择
      </a>

      <a
        href="javascript:void(0);"
        class="btn m-white m-btn-auto fileinput-exists"
        data-dismiss="fileinput"
        @click="clear()"
      >
        删除
      </a>
    </div>
    <div style="display:none;" class="noimg-pic">
      <img src="../assets/pages/img/noimage.png" />
    </div>
  </div>
</template>
<style>
@import '../assets/css/bootstrap-fileinput.css';
.thumbnail {
  padding: 0px !important;
  border-radius: 0 !important;
  border: none !important;
}

.thumbnail[data-role='initImgPreview'] {
  background: #f4f5f9;
}
.thumbnail[data-role='initImgPreview'] > img {
  opacity: 0;
}
</style>
<script>
import $ from 'jquery'
import '../assets/global/scripts/bootstrap-fileinput'
import { mapState, mapActions } from 'vuex'
import methods from '../methods'

let fu
export default {
  props: [
    'config'
  ] /*{
        config: {
            nolocal: {
                type: Boolean,
                default: false
            },
            space: {
                type: String,
                default: ''
            },
            name: {
                type: String
            },
            fileName: {
                type: String
            },
            file: {
                default: null
            },
            imgId: {
                type: String,
                default: null
            },
            audioUrl: {
                type: String
            },
            audioName: {
                type: String
            }
        }
    },*/,
  data() {
    return {
      id: `${Math.random()}`.substr(2),
      defaultAccepts: {
        video: '.mp4',
        image: '.jpg,.png,.jpeg',
        simple: '.jpg,.png,.jpeg',
        audio: '.mp3,.wma,.wav,.amr'
      }
    }
  },
  components: {},
  created() {
    fu = this

    /*this.config = this.config || {
            type : 'simple',
            name: 'file'
        };*/
  },
  mounted() {
    $(this.$el).on('click.fileinput.data-api', function(e) {
      var $this = $(this)
      if ($this.data('bs.fileinput')) return
      $this.fileinput($this.data())

      var $target = $(e.target).closest(
        '[data-dismiss="fileinput"],[data-trigger="fileinput"]'
      )
      if ($target.length > 0) {
        e.preventDefault()
        $target.trigger('click.bs.fileinput')
      }
    })

    this.$initImg = $(this.$el)
      .find('.noimg-pic img')
      .clone()
    $(this.$el)
      .removeData('bs.fileinput')
      .removeClass('fileinput-exists')
      .addClass('fileinput-new')

    $(this.$el)
      .find('.fileinput-preview')
      .empty()
  },
  watch: {
    'config.fileName': function(val, old) {
      if (val) {
        this.config.file = $(this.$el).find('[data-role="file"]')
      }

      this.checkReset()
    },
    'config.oid': function(val) {
      this.checkReset()

      if (val) {
        this._refreshImg()
      }
    },
    'config.imgId': function(val) {
      this.checkReset()

      if (val) {
        this._refreshImg()
      }
    }
  },
  methods: {
    ...mapActions([
      'showSelectImgWin',
      'showSelectVideoWin',
      'showSelectAudioWin',
      'showSelectArticleWin',
      'showSelectModel3dWin',
      'showSelectUnity3dWin'
    ]),
    ...methods,
    fileChg($ev) {
      let name = $($ev.target).val()
      let pos = name.lastIndexOf('\\')

      if (name && name.lastIndexOf('\\')) {
        name = name.substring(pos + 1)
      }
      this.config.fileName = name
    },
    checkReset() {
      if (
        !this.config ||
        (!this.config.fileName && !this.config.oid && !this.config.imgId)
      ) {
        this.reset()
      }
    },
    reset() {
      //$(this.$el).find('[data-role="initImgPreview"]').html(this.$initImg);
      $(this.$el)
        .find('[data-dismiss="fileinput"]')
        .trigger('click')
    },
    clear() {
      this.config.fileName = null
      this.config.oid = null
      this.config.imgId = null
      this.config.audioUrl = null
      this.reset()
      this.pauseAudio()
    },
    _refreshImg() {
      var $el = $(this.$el)
      $el.addClass('fileinput-exists')
      $el.removeClass('fileinput-new')

      var $cnt

      if (this.config.url) {
        $cnt = $('<img/>')
        $cnt.attr('src', this.config.url)

        $cnt.css('max-height', '250px')
        $cnt.css('max-width', '100%')
      } else if (this.config.fileName) {
        $cnt = this.config.fileName
      }

      $el
        .find('.fileinput-preview')
        .empty()
        .append($cnt)
    },
    openSpace() {
      let self = this
      this.showSelectImgWin({
        ok: function(img) {
          if (!img) {
            return
          }

          self.config.fileName = null
          self.config.url = img.imgUrl
          self.config.imgId = img.objectId
          self.config.oid = img.objectId

          self._refreshImg()
        }
      })
    },
    openVideoSpace() {
      let self = this

      this.showSelectVideoWin({
        ok: function(video) {
          if (!video) {
            return
          }

          self.config.fileName = null
          self.config.url = video.coverUrl
          self.config.oid = video.objectId

          self._refreshImg()
        }
      })
    },
    openArticleSpace() {
      let self = this

      this.showSelectArticleWin({
        ok: function(article) {
          if (!article) {
            return
          }

          self.config.fileName = null
          self.config.url = article.coverUrl
          self.config.oid = article.objectId

          self._refreshImg()
        }
      })
    },
    openModel3dSpace() {
      let self = this

      this.showSelectModel3dWin({
        ok: function(m3d) {
          if (!m3d) {
            return
          }

          self.config.fileName = null
          self.config.url = m3d.coverUrl
          self.config.oid = m3d.objectId

          self._refreshImg()
        }
      })
    },
    openUnity3dSpace() {
      let self = this

      this.showSelectUnity3dWin({
        ok: function(u3d) {
          if (!u3d) {
            return
          }

          self.config.fileName = null
          self.config.url = u3d.coverUrl
          self.config.oid = u3d.objectId

          self._refreshImg()
        }
      })
    },

    openMiniappSpace() {
      let self = this

      this.showSelectUnity3dWin({
        ok: function(u3d) {
          if (!u3d) {
            return
          }

          self.config.fileName = null
          self.config.url = u3d.coverUrl
          self.config.oid = u3d.objectId

          self._refreshImg()
        },
        type: 'miniapp'
      })
    },
    openAudioSpace() {
      let self = this

      this.showSelectAudioWin({
        ok: function(audio) {
          if (!audio) {
            return
          }

          self.config.fileName = null
          self.config.audioUrl = audio.audioUrl
          self.config.audioName = audio.title
          self.config.url = audio.coverUrl
          self.config.oid = audio.objectId
          self.config.totalTime = audio.totalTime

          // console.log('*******************');
          // console.log(self.config);
          self._refreshImg()
        }
      })
    }
  }
}
</script>
